export default __webpack_public_path__ + "media/images/elephant_ui_disappointed-7b990e9fc67ef3316f2c27d24f18d876.svg";